// src/components/ui/button.js
import React, { useEffect, useState } from "react";
import { Button, Popconfirm, DatePicker } from 'antd';
import dayjs from 'dayjs';

export function DatePopupconfirm({ onConfirm, customerId, record_id, is_active }) {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setSelectedDate(dayjs());
  }, [visible])

  const handleConfirm = () => {
    if (selectedDate) {
      if (customerId) {
        onConfirm(customerId, record_id, selectedDate.format('YYYY-MM-DD'));
      } else {
        onConfirm(record_id, selectedDate.format('YYYY-MM-DD'));
      }
    }
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  }

  return (
    <Popconfirm
      title={
        <>
          {
            is_active ? 
            (
              <>
                <div style={{ marginBottom: 8 }}>
                  {`Choose deactivation date:`}
                </div>
                <DatePicker
                  value={selectedDate}
                  onChange={setSelectedDate}
                  style={{ width: '100%' }}
                />
              </>
            ) :
            (
              <>You want to activate?</>
            ) 
          }
        </>
      }
      open={visible}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      okText={
        is_active? 
        'Deactivate' :
        'Activate'
      }
      cancelText="Cancel"
    >
      <Button onClick={() => setVisible(true)}>{is_active ? 'Deactivate': 'Activate'}</Button>
    </Popconfirm>
  )
}
